<template>
  <div style="margin: 7%">
    <div v-if="isRightUser">
      <div class="container" v-if="!isEmailSubmitted">
        <email-verification
          :page-title="title"
          ref="refEmailVerification"
          :erorr-message="emailSubmitErorrMessage"
          :is-submitted="isEmailSubmitted"
          @submit="onSubmitEmail"
        />
      </div>
      <div v-if="isEmailSubmitted">
        <scc-user-details
          ref="refUserDetails"
          :userProfileId="userId"
          :isUserProfile="userProfile"
        />
      </div>
    </div>
    <div v-else>
      Please contact SCC Admin, to confirm you permissions. The user Id does not
      match.
    </div>
  </div>
</template>
<script>
import Vue from 'vue';

import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import EmailVerification from '../../auth/components/email-verification.vue';
import SccUserDetails from '../components/scc-user-details.vue';
import { CONFIRM_USER_EMAIL } from '../../auth/store';

Vue.use(ButtonPlugin);
Vue.use(TextBoxPlugin);

export default {
  name: 'ManageSCCUser',
  components: {
    EmailVerification,
    SccUserDetails,
  },
  created() {
    this.userId = this.$route.params.id;
    this.loggedUserId = this.$store.getters.loggedUser.id;
    if (this.userId !== null && this.userId !== 'null') {
      this.isEmailSubmitted = true;
    }
  },
  mounted() {},
  computed: {
    isLogedUserAdmin() {
      return (
        this.isCurrentUserInRole('admin')
        || this.isCurrentUserInRole('superadmin')
      );
    },
    isRightUser() {
      return this.isLogedUserAdmin || this.userId === this.loggedUserId;
    },
  },
  data() {
    return {
      title: 'Add New SCC User Account',
      isEmailSubmitted: false,
      userId: null,
      currentUser: null,
      userProfile: false,
      emailSubmitErorrMessage: null,
      loggedUserId: null,
    };
  },
  methods: {
    isCurrentUserInRole(roleName) {
      let roleIndex = -1;
      const LogedUser = this.$store.getters.loggedUser;
      if (LogedUser && LogedUser.roles) {
        roleIndex = LogedUser.roles.findIndex(
          (r) => r.roleName.toLowerCase() === roleName,
        );
      }
      return roleIndex >= 0;
    },
    onCancelButtonClick() {
      this.$router.push('/');
    },
    btnComplete() {},
    async onSubmitEmail(email) {
      // this.$parent.$parent.notificationToasts.length = 0;
      const refEmailVerify = this.$refs.refEmailVerification;
      const userName = email;
      const rootURL = window.location.host;
      if (refEmailVerify.isEmailValid) {
        try {
          await this.$store.dispatch(CONFIRM_USER_EMAIL, {
            userName,
            rootURL,
            confirmType: 'admin-registration',
          });
          // console.log('this.$store.getters.userDetails.status:',
          // this.$store.getters.userDetails.status);
          if (this.$store.getters.userDetails.status === 200) {
            this.currentUser = this.$store.getters.userDetails.data;
            this.userId = this.currentUser.userId;
            this.$parent.$parent.notificationToasts.push({
              title: 'Thank you for your request!',
              content: '',
              cssClass: 'e-toast-success',
              timeOut: 5000,
            });
            this.userEmail = email;
            this.isEmailSubmitted = true;
          } else if (this.$store.getters.userDetails) {
            switch (this.$store.getters.userDetails) {
              case 409:
                this.erorrMessage = 'Account exist with given email id.';
                break;
              case 403:
                this.erorrMessage = 'Account exist with given email id.';
                break;
              case 404:
                this.$router.push('/NotFound');
                break;
              default:
                this.erorrMessage = 'Oops, Something went wrong. We are working on getting this fixed as soon as we can. You may be able to try again shortly. If you continue to experience this issue, you can contact ASCA Tanks at ascatanks@safetycodes.ab.ca or by calling 1-888-413-0099';
            }
            if (this.erorrMessage) {
              this.$parent.$parent.notificationToasts.push({
                title: 'Error!',
                content: this.erorrMessage,
                cssClass: 'e-toast-danger',
                timeOut: 5000,
              });
            }
            this.emailSubmitErorrMessage = this.erorrMessage;
          }
        } catch (err) {
          if (err.Status === 408) {
            this.$parent.$parent.notificationToasts.push({
              title: 'Error!',
              content: 'Sorry, Something went wrong! Please try again later.',
              cssClass: 'e-toast-danger',
              timeOut: 5000,
            });
          }
          if (err.Status === 404) {
            this.$router.push('/NotFound');
          }
        }
      } else {
        refEmailVerify.validateEmail();
        this.$parent.$parent.notificationToasts.push({
          title: 'Error!',
          content: 'Please provide valid email id.',
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
      }
      if (this.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$refs.notifierRef.show();
      }
    },
  },
};
</script>
<style>
.container {
  padding: 10px 10px 16px 10px;
}
</style>
